import { site } from "../config/site";
import { shouldShowDeliveryNotice } from "../lib/launch";

export function DeliveryNotice() {
  if (!shouldShowDeliveryNotice()) {
    return null;
  }

  return (
    <p className="delivery-notice" role="note">
      {site.deliveryNotice}
    </p>
  );
}
